/*eslint-disable */
import { Box, Button, CircularProgress, Tab, Tabs, Typography } from "@mui/material";
import { useState } from "react";
import DOMPurify from "dompurify";
import { PUBLISH_BLOG_SHOPIFY, PUBLISH_BLOG_WORDPRESS } from "../../gql/mutations/userWebSiteVisit";
import { useMutation } from "@apollo/client";
import { GetProjectByUserId } from "../../hooks/userWebsiteData";
import { usePopup } from "../../context/commonPop";
import JoditEditor from "jodit-react";

function ShowAdvanceContent({ title, items, projectId, titleAndMetaDescription }) {
  const { handleOpen } = usePopup();
  const [publishBlogShopify] = useMutation(PUBLISH_BLOG_SHOPIFY);
  const [publishBlogWordpress] = useMutation(PUBLISH_BLOG_WORDPRESS);
  const { allProjectWithSessionId } = GetProjectByUserId({ RequireSessionId: 1 });
  const [isCopied, setIsCopied] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [contentToEdit, setContentToEdit] = useState(generateHTML(items));
  // const [mainContent, setMainContent] = useState(contentToEdit);
  const handleCopyButton = () => {
    const allContent = items.map(item => item.Content).join("\n");

    navigator.clipboard
      .writeText(allContent)
      .then(() => {
        setIsCopied(true);
      })
      .catch(err => {
        console.error("Failed to copy content: ", err);
      });
  };

  const projectData = allProjectWithSessionId.find(project => project.id === projectId);

  const hasShopifyProject = projectData && projectData.appType === "Shopify" && projectData.isConnected;
  const hasWordpressProject = projectData && projectData.appType === "Wordpress" && projectData.isConnected;

  const handlePublish = async () => {
    setIsLoading(true);
    try {
      const filteredProject = allProjectWithSessionId.find(project => project.id === projectId);
      if (!filteredProject) {
        console.error("Project not found");
        return;
      }

      const contentToSend = isEditing ? contentToEdit : generateHTML(items);

      const { appType, website, isConnected } = filteredProject;
      if (appType === "Shopify" && isConnected) {
        const { data } = await publishBlogShopify({
          variables: {
            inputdata: {
              body: contentToSend,
              description: "Testing Description For Blog Upload",
              projectId,
              title,
            },
          },
        });
        if (data) {
          setIsLoading(false);
          handleOpen(true, " Shopify Blog Published Successfully");
        }
      } else if (appType === "Wordpress" && isConnected) {
        const { data } = await publishBlogWordpress({
          variables: {
            inputdata: {
              body: contentToSend,
              description: "Testing Description For Blog Upload",
              projectId,
              domain: website,
              title,
            },
          },
        });
        if (data) {
          setIsLoading(false);
          handleOpen(true, " WordPress Blog Published Successfully");
        }
      }
    } catch (error) {
      setIsLoading(false);
      handleOpen(true, "Unsupported apptype");
      console.error("Error publishing blog:", error);
    }
  };

  const totalCount = items.reduce((acc, item) => acc + parseInt(item.Count), 0);

  function generateHTML(items) {
    let html = "";
    html += `<h1>${title}</h1>`;
    items.forEach((item, index) => {
      html += `<h2>${item.Topic}</h2>`;
      html += `<p>${item.Content}</p>`;
      if (index < items.length - 1) {
        html += "<hr>";
      }
    });

    return html;
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    if (newValue === 1) {
      setIsEditing(true);
    } else {
      setIsEditing(false);
    }
  };

  const handleEditButton = () => {
    setContentToEdit(prev => prev || generateHTML(items));
  };

  return (
    <Box className="MargeContentWrapper">
      <Box className="CopyWrapper">
        <Typography component="p">
          Total Count: <Typography component="span">{totalCount}</Typography>
        </Typography>
      </Box>
      <Box className="ContentWrapper">
        <Box className="TabLabelWrapper">
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab label="Preview" />
            <Tab label="Edit" onClick={handleEditButton} />
          </Tabs>
          {isLoading ? (
            <CircularProgress style={{ width: "20px", height: "20px" }} />
          ) : (
            <Box className="PublishBtnWrapper">
              <Button onClick={handleCopyButton}>{isCopied ? "Copied!" : "Copy"}</Button>
              <Button onClick={handlePublish} disabled={!hasShopifyProject && !hasWordpressProject}>
                Publish
              </Button>
            </Box>
          )}
        </Box>
        {tabValue === 0 ? (
          <>
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(contentToEdit) }} />
          </>
        ) : (
          <>
            <JoditEditor value={contentToEdit} onChange={setContentToEdit} tabIndex={1} />
          </>
        )}
      </Box>
    </Box>
  );
}

export default ShowAdvanceContent;
